const krProcess = () => import('./kr/processDetails');
const krProcessList = () => import('./kr/processList');

const processRouter = [
  {
    path: '/process/kr/processDetails/:applyid/:id',
    name: 'krProcessDetail',
    component: krProcess,
    meta: { c: 'process', a: 'krDetail' }
  },
  {
    path: '/process/kr/processList',
    name: 'krProcessList',
    component: krProcessList,
    meta: { c: 'process', a: 'krList' }
  },
];

export default processRouter;
